module.exports = __webpack_public_path__ + "static/media/IMG_1313.e6923236.JPG";